import { render, staticRenderFns } from "./ChosenBrandItem.vue?vue&type=template&id=4641d4e1&scoped=true"
import script from "./ChosenBrandItem.vue?vue&type=script&lang=js"
export * from "./ChosenBrandItem.vue?vue&type=script&lang=js"
import style0 from "./ChosenBrandItem.vue?vue&type=style&index=0&id=4641d4e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4641d4e1",
  null
  
)

export default component.exports